var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex relative rounded"},[_c('textarea',{ref:"textarea",staticClass:"gwd-textarea",class:[
      _vm.error || !_vm.maxLengthCheck
        ? 'border-2 !border-danger border-opacity-50 px-1 focus:border-opacity-0'
        : '',
      _vm.heading ? 'text-2xl' : '',
      _vm.borderless ? 'borderless' : null,
      _vm.background
        ? 'bg-offwhite px-1 shadow'
        : 'bg-transparent hover:bg-white focus:bg-white',
      _vm.warnMaxLengthOnPaste
        ? 'border-2 !border-danger border-opacity-50 px-1 focus:border-opacity-0'
        : '' ],attrs:{"placeholder":_vm.placeholder,"rows":_vm.key,"maxlength":_vm.maxLength},domProps:{"value":_vm.value},on:{"input":_vm.handleInput,"scroll":_vm.resize,"paste":_vm.handlePaste}}),_vm._v(" "),(_vm.required)?_c('span',{staticClass:"required"}):_vm._e(),(_vm.maxLength)?_c('span',{staticClass:"max-length-text",class:[_vm.maxLengthTextColor]},[_vm._v(" "+_vm._s(_vm.value ? _vm.value.length : 0)+"/"+_vm._s(_vm.maxLength)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }